import { render } from "./serviceheader.vue?vue&type=template&id=fa044fb0&scoped=true"
const script = {}

import "./serviceheader.vue?vue&type=style&index=0&id=fa044fb0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa044fb0"]])

export default __exports__